// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, type IntlShape } from 'react-intl';
import { type RouterHistory, withRouter } from 'react-router-dom';

import { bindActionCreatorsSafe } from 'util/safeDispatch';
import localizedStrings from 'util/localizedStrings';
import PortsRow from './PortsRow';
import { restartServer } from 'state/commands/adminPropertiesCommands';
import type { Dispatch } from 'state/types';

type Props = {
  intl: IntlShape,
  restartServer: typeof restartServer,
  history: RouterHistory,
};

type State = {
  dirty: boolean,
};

class PortsPage extends Component<Props, State> {
  handlePortChanged: Function;
  handleRestartServer: Function;

  constructor() {
    super();
    this.handlePortChanged = this.handlePortChanged.bind(this);
    this.handleRestartServer = this.handleRestartServer.bind(this);
    this.state = {
      dirty: false,
    };
  }

  handleRestartServer() {
    this.props.history.replace('/status');
    this.props.restartServer();
  }

  handlePortChanged() {
    this.setState({ dirty: true });
  }

  render() {
    const {
      intl: { formatMessage },
    } = this.props;
    return (
      <div
        className="page-contents columns is-gapless"
        data-test-name="ports-page"
      >
        <div className="column">
          <header className="page-header">
            <FormattedMessage {...localizedStrings.PORT_TITLE} />
          </header>
          <section className="section page-contents-textured portfolio-form-container">
            <div className="box">
              <PortsRow
                label={localizedStrings.ESP_PORT_ADMIN_WEB_APP}
                onPortChanged={this.handlePortChanged}
                portKey={'esp.port.admin-web-app'}
                defaultPort="8091"
              />
              <PortsRow
                label={localizedStrings.ESP_PORT_ADMIN_WEB_APP_SSL}
                onPortChanged={this.handlePortChanged}
                portKey={'esp.port.admin-web-app-ssl'}
                defaultPort="9453"
              />
              <PortsRow
                label={localizedStrings.ESP_PORT_HTTP}
                onPortChanged={this.handlePortChanged}
                portKey={'esp.port.http'}
                defaultPort="8090"
              />
              <PortsRow
                label={localizedStrings.ESP_PORT_SSL}
                onPortChanged={this.handlePortChanged}
                portKey={'esp.port.https'}
                defaultPort="9443"
              />
              <hr />
              <div className="ports-restart-area">
                {formatMessage(localizedStrings.PORT_RESTART_NOTICE)}
                <button
                  className="button is-primary is-outlined"
                  disabled={!this.state.dirty}
                  data-test-name="restart-server"
                  onClick={this.handleRestartServer}
                  style={{ marginLeft: '32px' }}
                >
                  <span className="icon">
                    <i className="fa fa-repeat fa-rotate-270" />
                  </span>
                  <FormattedMessage
                    {...localizedStrings.STATUS_RESTART_SERVER}
                  />
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export default connect(
  state => ({}),
  (dispatch: Dispatch) =>
    bindActionCreatorsSafe({
      restartServer,
    })
)(withRouter(injectIntl(PortsPage)));



// WEBPACK FOOTER //
// ./src/view/Pages/GlobalSettingsPages/PortsPage.js